import * as ambassadorWixEcomV1PickupLocation from './ecom-v1-pickup-location-pickup-locations.http.js';
import * as ambassadorWixEcomV1PickupLocationTypes from './ecom-v1-pickup-location-pickup-locations.types.js';
import * as ambassadorWixEcomV1PickupLocationUniversalTypes from './ecom-v1-pickup-location-pickup-locations.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createPickupLocation(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1PickupLocationUniversalTypes.CreatePickupLocationRequest,
  ambassadorWixEcomV1PickupLocationTypes.CreatePickupLocationRequest,
  ambassadorWixEcomV1PickupLocationUniversalTypes.CreatePickupLocationResponse &
    ambassadorWixEcomV1PickupLocationUniversalTypes.CreatePickupLocationResponseNonNullableFields,
  ambassadorWixEcomV1PickupLocationTypes.CreatePickupLocationResponse &
    ambassadorWixEcomV1PickupLocationTypes.CreatePickupLocationResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1PickupLocation.createPickupLocation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/pickup-locations',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getPickupLocation(): __PublicMethodMetaInfo<
  'GET',
  { pickupLocationId: string },
  ambassadorWixEcomV1PickupLocationUniversalTypes.GetPickupLocationRequest,
  ambassadorWixEcomV1PickupLocationTypes.GetPickupLocationRequest,
  ambassadorWixEcomV1PickupLocationUniversalTypes.GetPickupLocationResponse &
    ambassadorWixEcomV1PickupLocationUniversalTypes.GetPickupLocationResponseNonNullableFields,
  ambassadorWixEcomV1PickupLocationTypes.GetPickupLocationResponse &
    ambassadorWixEcomV1PickupLocationTypes.GetPickupLocationResponseNonNullableFields
> {
  const payload = { pickupLocationId: ':pickupLocationId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1PickupLocation.getPickupLocation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/pickup-locations/{pickupLocationId}',
    pathParams: { pickupLocationId: 'pickupLocationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updatePickupLocation(): __PublicMethodMetaInfo<
  'PATCH',
  { pickupLocationId: string },
  ambassadorWixEcomV1PickupLocationUniversalTypes.UpdatePickupLocationRequest,
  ambassadorWixEcomV1PickupLocationTypes.UpdatePickupLocationRequest,
  ambassadorWixEcomV1PickupLocationUniversalTypes.UpdatePickupLocationResponse &
    ambassadorWixEcomV1PickupLocationUniversalTypes.UpdatePickupLocationResponseNonNullableFields,
  ambassadorWixEcomV1PickupLocationTypes.UpdatePickupLocationResponse &
    ambassadorWixEcomV1PickupLocationTypes.UpdatePickupLocationResponseNonNullableFields
> {
  const payload = { pickupLocation: { id: ':pickupLocationId' } } as any;

  const getRequestOptions =
    ambassadorWixEcomV1PickupLocation.updatePickupLocation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/pickup-locations/{pickupLocation.id}',
    pathParams: { pickupLocationId: 'pickupLocationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deletePickupLocation(): __PublicMethodMetaInfo<
  'DELETE',
  { pickupLocationId: string },
  ambassadorWixEcomV1PickupLocationUniversalTypes.DeletePickupLocationRequest,
  ambassadorWixEcomV1PickupLocationTypes.DeletePickupLocationRequest,
  ambassadorWixEcomV1PickupLocationUniversalTypes.DeletePickupLocationResponse,
  ambassadorWixEcomV1PickupLocationTypes.DeletePickupLocationResponse
> {
  const payload = { pickupLocationId: ':pickupLocationId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1PickupLocation.deletePickupLocation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/pickup-locations/{pickupLocationId}',
    pathParams: { pickupLocationId: 'pickupLocationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryPickupLocation(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1PickupLocationUniversalTypes.QueryPickupLocationRequest,
  ambassadorWixEcomV1PickupLocationTypes.QueryPickupLocationRequest,
  ambassadorWixEcomV1PickupLocationUniversalTypes.QueryPickupLocationResponse &
    ambassadorWixEcomV1PickupLocationUniversalTypes.QueryPickupLocationResponseNonNullableFields,
  ambassadorWixEcomV1PickupLocationTypes.QueryPickupLocationResponse &
    ambassadorWixEcomV1PickupLocationTypes.QueryPickupLocationResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1PickupLocation.queryPickupLocation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/pickup-locations/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function addDeliveryRegion(): __PublicMethodMetaInfo<
  'POST',
  { pickupLocationId: string },
  ambassadorWixEcomV1PickupLocationUniversalTypes.AddDeliveryRegionRequest,
  ambassadorWixEcomV1PickupLocationTypes.AddDeliveryRegionRequest,
  ambassadorWixEcomV1PickupLocationUniversalTypes.AddDeliveryRegionResponse &
    ambassadorWixEcomV1PickupLocationUniversalTypes.AddDeliveryRegionResponseNonNullableFields,
  ambassadorWixEcomV1PickupLocationTypes.AddDeliveryRegionResponse &
    ambassadorWixEcomV1PickupLocationTypes.AddDeliveryRegionResponseNonNullableFields
> {
  const payload = { pickupLocationId: ':pickupLocationId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1PickupLocation.addDeliveryRegion(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/pickup-locations/{pickupLocationId}/add-delivery-region',
    pathParams: { pickupLocationId: 'pickupLocationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function removeDeliveryRegion(): __PublicMethodMetaInfo<
  'POST',
  { pickupLocationId: string },
  ambassadorWixEcomV1PickupLocationUniversalTypes.RemoveDeliveryRegionRequest,
  ambassadorWixEcomV1PickupLocationTypes.RemoveDeliveryRegionRequest,
  ambassadorWixEcomV1PickupLocationUniversalTypes.RemoveDeliveryRegionResponse &
    ambassadorWixEcomV1PickupLocationUniversalTypes.RemoveDeliveryRegionResponseNonNullableFields,
  ambassadorWixEcomV1PickupLocationTypes.RemoveDeliveryRegionResponse &
    ambassadorWixEcomV1PickupLocationTypes.RemoveDeliveryRegionResponseNonNullableFields
> {
  const payload = { pickupLocationId: ':pickupLocationId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1PickupLocation.removeDeliveryRegion(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/pickup-locations/{pickupLocationId}/remove-delivery-region',
    pathParams: { pickupLocationId: 'pickupLocationId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreatePickupLocation(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1PickupLocationUniversalTypes.BulkCreatePickupLocationRequest,
  ambassadorWixEcomV1PickupLocationTypes.BulkCreatePickupLocationRequest,
  ambassadorWixEcomV1PickupLocationUniversalTypes.BulkCreatePickupLocationResponse &
    ambassadorWixEcomV1PickupLocationUniversalTypes.BulkCreatePickupLocationResponseNonNullableFields,
  ambassadorWixEcomV1PickupLocationTypes.BulkCreatePickupLocationResponse &
    ambassadorWixEcomV1PickupLocationTypes.BulkCreatePickupLocationResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1PickupLocation.bulkCreatePickupLocation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/pickup-locations/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdatePickupLocation(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixEcomV1PickupLocationUniversalTypes.BulkUpdatePickupLocationRequest,
  ambassadorWixEcomV1PickupLocationTypes.BulkUpdatePickupLocationRequest,
  ambassadorWixEcomV1PickupLocationUniversalTypes.BulkUpdatePickupLocationResponse &
    ambassadorWixEcomV1PickupLocationUniversalTypes.BulkUpdatePickupLocationResponseNonNullableFields,
  ambassadorWixEcomV1PickupLocationTypes.BulkUpdatePickupLocationResponse &
    ambassadorWixEcomV1PickupLocationTypes.BulkUpdatePickupLocationResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1PickupLocation.bulkUpdatePickupLocation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/bulk/pickup-locations/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeletePickupLocation(): __PublicMethodMetaInfo<
  'DELETE',
  {},
  ambassadorWixEcomV1PickupLocationUniversalTypes.BulkDeletePickupLocationRequest,
  ambassadorWixEcomV1PickupLocationTypes.BulkDeletePickupLocationRequest,
  ambassadorWixEcomV1PickupLocationUniversalTypes.BulkDeletePickupLocationResponse &
    ambassadorWixEcomV1PickupLocationUniversalTypes.BulkDeletePickupLocationResponseNonNullableFields,
  ambassadorWixEcomV1PickupLocationTypes.BulkDeletePickupLocationResponse &
    ambassadorWixEcomV1PickupLocationTypes.BulkDeletePickupLocationResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1PickupLocation.bulkDeletePickupLocation(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/bulk/pickup-locations/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}
